enum LanguageCode {
  Cs = "CS",
  En = "EN",
  De = "DE",
  Ru = "RU",
  Pl = "PL",
  Hu = "HU",
}

export default LanguageCode;
